import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table", "rowCount"]

  connect() {
    this.updateRowCount()
  }

  removeColumn(event) {
    const columnIndex = event.target.dataset.columnIndex
    const columnsToRemove = this.tableTarget.querySelectorAll(`.column-${columnIndex}`)

    columnsToRemove.forEach(element => {
      element.remove()
    })
  }

  removeRow(event) {
    const row = event.target.closest("tr")
    if (row) {
      row.remove()
    }

    this.updateRowCount()
  }

  updateRowCount() {
    this.rowCountTarget.innerText = this.rowCount
  }

  get rowCount() {
    return this.element.querySelectorAll("tbody tr").length
  }
}
